export const getters = {
    getLancamentoBancario: state => state.lancamentoBancario,
    getLancamentosBancarios: state => state.lancamentosBancarios,
    getModalCadastroLancamentoBancario: state => state.modalCadastroLancamentoBancario,
    getModalExcluirLancamentoBancario: state => state.modalExcluirLancamentoBancario,
    getShowInputAnexoLancamentoBancario: state => state.showInputAnexoLancamentoBancario,
}

export default {}